
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#C3AFA3","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4.72 4.417a1.25 1.25 0 110 2.499 1.25 1.25 0 010-2.5zM13.467 11.303l-2.915-4.37a.563.563 0 00-.929-.01L8.127 9.067 7.2 8.322a.562.562 0 00-.79.087l-.03.04-1.91 2.867","stroke-width":"1.000005"}}),_c('path',{attrs:{"d":"M1.5 2.015a1 1 0 00-1 1v9.97a1 1 0 001 1h13a1 1 0 001-1v-8a1 1 0 00-.284-.698l-1.922-1.97a1.001 1.001 0 00-.716-.302H1.5z","stroke-width":"1.000005"}})])])
          )
        }
      }
    